// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Onm8","col":"styles_col__2JprR"};